export default __webpack_public_path__ + "static/media/2023 (1).6502bd25.jpg";